import {useRef} from 'react';
import {onRender} from './intentTypes';
import type {Intent} from '../intent';

export function captureProps<Props = never>(): {
  intent: Intent<Props>;
  props: Props;
} {
  const result = {
    intent: onRender<Props>((props) => {
      result.props = props;
    }),
    props: {} as Props,
  };
  return result;
}

export const logRenderCount = onRender(function useLogRenderCount() {
  const counter = useRef(0);
  counter.current++;
  // eslint-disable-next-line no-console
  console.log('[render]', counter.current);
});
